
import app from '../index';

export default class RechnungNeuController {

  constructor($routeParams, $scope) {
    this.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    this.vorlageId = $routeParams.vorlageId;

    $scope.$watch("vm.neueRechnung.Kunde", (newValue, oldValue) => {
      if (oldValue === newValue) {
        return;
      }

      if (!newValue) {
        this.neueRechnung.Anschrift = null;
        this.neueRechnung.Lieferanschrift = null;
      } else {
        this.neueRechnung.Anschrift = newValue.Anschrift;
        if (newValue.Lieferanschrift) {
          this.neueRechnung.Lieferanschrift = this.neueRechnung.Anschrift;
        } else {
          this.neueRechnung.Lieferanschrift = newValue.Lieferanschrift;
        }
      }
    });

    this.refresh();
  }

  refresh() {

    if (this.vorlageId) {

      this.neueRechnung = app.api.rechnungen.aendern({
        id: this.vorlageId
      }, (rechnung) => {

        // input requires a date
        rechnung.Datum = new Date(rechnung.Datum);

        if (rechnung.IhrDatum) {
          rechnung.IhrDatum = new Date(rechnung.IhrDatum);
        }

        for (var i = 0; i < rechnung.Details.length; i++) {
          var detail = rechnung.Details[i];

          if (!detail.Artikel) {
            detail.Artikel = detail.Bezeichnung;
          }
        }

        this.newDetail();
      });
    } else {
      this.neueRechnung = {
        Datum: new Date(),
        PortoVerpackung: 0,
        NettoBetrag: 0,
        NettoWarenwert: 0,
        BruttoBetrag: 0,
        Mehrwertsteuer: 19.0,
        Versandart: "per Post ab Lager",
        Details: []
      };
      this.newDetail();
    }
  }

  getKunden(name) {
    return app.api.kunden.query({
        name: name
      })
      .$promise
      .then((response) => {
        return response;
      });
  }

  getArtikel(name) {
    return app.api.artikel.query({
        bezeichnung: name
      })
      .$promise
      .then((response) => {
        return response;
      });
  }

  updateGesamtBetrag(details) {
    this.neueRechnung.NettoWarenwert = 0;
    for (var i = 0, n = details.length; i < n; i++) {
      this.neueRechnung.NettoWarenwert += details[i].Betrag;
    }
  }

  updateBetrag(detail) {
    if (!detail.Preis) {
      detail.Preis = 0;
    }

    if (!detail.Menge) {
      detail.Menge = 0;
    }

    detail.Betrag = detail.Menge * detail.Preis;
    this.updateGesamtBetrag(this.neueRechnung.Details);
  }

  detectNewLine(detail) {
    if (detail.IsNewLine) {
      detail.IsNewLine = false;
      this.newDetail(detail);
    }
  }

  newDetail(detail) {
    var einheit = "Stck.";
    var menge = 0;
    var preis = 0;

    if (detail) {
      einheit = detail.Einheit;
      menge = detail.Menge;
      preis = detail.Preis;
    }

    var newDetail = {
      IsNewLine: true,
      Menge: menge,
      Einheit: einheit,
      Artikel: null,
      Preis: preis,
      Betrag: 0
    };

    this.neueRechnung.Details.push(newDetail);
    this.updateBetrag(newDetail);
  }

  removeDetail(index) {
    this.neueRechnung.Details.splice(index, 1);
  }

  updateArtikel(detail) {
    if (detail.Artikel && detail.Artikel.Bezeichnung) {
      detail.Bezeichnung = detail.Artikel.Bezeichnung;
    } else {
      detail.Bezeichnung = detail.Artikel;
    }
  }

  save() {
    this.saving = true;
    app.api.rechnungen.save(this.neueRechnung, (success) => {
      this.saving = false;
      app.$location.path("rechnungen/" + success.Id);
    });
  }
}

RechnungNeuController.$inject = ['$routeParams', '$scope'];



/** WEBPACK FOOTER **
 ** ./public/app/rechnungen/RechnungNeuController.js
 **/